module.exports = new __parcel__URL__("tower.d2df14e8.webp").toString();